/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Link from 'next/link';
import Typography from '@common_typography/index';
import useMediaQuery from '@hook/useMediaQuery';
import cx from 'classnames';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { COLORS } from '@theme_vars';
import { setResolver, getResolver } from '@helper_localstorage';
import { createExcerpt } from '@helper_text';
import Router from 'next/router';
import { useTranslation } from 'next-i18next';

const handleClick = async (url, id) => {
    if (id) {
        const urlResolver = getResolver();
        urlResolver[url] = {
            type: 'CATEGORY',
            id,
        };
        await setResolver(urlResolver);
    }
};

const ItemBreadcrumb = ({
    icon,
    iconOnly,
    id,
    url,
    label,
    labelStyle,
    seperate,
    seperate2,
}) => {
    const { isMobile } = useMediaQuery();

    return (
        <div className={cx(
            'swift-section-breadcrumb-item',
            'flex',
            'items-center',
        )}
        >
            {
                url !== '#' ? (
                    <Link href={url} onClick={() => handleClick(url, id)}>
                        <Typography
                            variant="bd-2b"
                            style={labelStyle}
                            className={cx(
                                'mobile:text-sm tablet:text-[13px] font-semibold capitalize',
                                'whitespace-nowrap',
                                'flex',
                                'items-center hover:underline',
                                '!text-neutral-black',
                            )}
                        >
                            {iconOnly && icon }
                            {!iconOnly && isMobile ? createExcerpt(label, 40) : label}
                        </Typography>
                    </Link>
                ) : (
                    <Typography
                        variant="bd-2b"
                        style={labelStyle}
                        className={cx(
                            'mobile:text-sm tablet:text-[13px] font-semibold capitalize',
                            'whitespace-nowrap',
                            'flex cursor-default',
                            '!text-neutral-black',
                        )}
                    >
                        {iconOnly && icon }
                        {!iconOnly && isMobile ? createExcerpt(label, 40) : label}
                    </Typography>
                )
            }
            {
                seperate && <Typography variant="bd-2b" className="mx-[12px] font-semibold" color="text-neutral-bcSeparator">/</Typography>
            }
            {
                seperate2 && <Typography variant="bd-2b" className="mx-[15px] font-normal" color="text-neutral-bcSeparator">|</Typography>
            }
        </div>
    );
};

const Breadcrumb = ({
    data = [],
    withHome = true,
    className,
}) => {
    const { t } = useTranslation(['common']);

    const handleBack = () => {
        Router.back();
    };
    return (
        <div className={cx(
            'swift-section-breadcrumb',
            'flex flex-wrap',
            'items-center',
            'mb-[10px]',
            'overflow-x-auto tablet:!px-0',
            className,
        )}
        >
            {
                withHome && (
                    <>
                        <ChevronLeftIcon className="h-[18px] w-[18px] text-neutral-bcSeparator mr-[10px]" />
                        <div onClick={() => handleBack()} className="cursor-pointer">
                            <Typography
                                variant="bd-2b"
                                className={cx(
                                    'mobile:text-sm tablet:text-[13px] font-semibold capitalize',
                                    'whitespace-nowrap',
                                    'flex',
                                    'items-center hover:underline',
                                    '!text-neutral-black',
                                )}
                            >
                                {t('common:back')}
                            </Typography>
                        </div>
                        <Typography variant="bd-2b" className="mx-[15px] font-normal !text-[16px]" color="text-neutral-bcSeparator">|</Typography>
                    </>
                )
            }
            <ItemBreadcrumb
                key="breadcrumb-home"
                url="/"
                label={t('common:home:title')}
                seperate
            />
            {
                data && data.map((item, index) => {
                    const isActive = item?.active || false;
                    return (
                        <ItemBreadcrumb
                            key={`breadcrumb-${index}-${item?.id}`}
                            id={item?.id}
                            url={item?.link}
                            label={item?.label}
                            labelStyle={{ color: COLORS.neutral.black }}
                            seperate={!isActive}
                        />
                    );
                })
            }
        </div>
    );
};

export default Breadcrumb;
